// Sponsorship.jsx
import React, { useState } from "react";
import LexacquireTopnav from "./lexacquiretopnav";
import "./Sponsorship.css";

export default function Sponsorship() {
  const [billing, setBilling] = useState("yearly"); // "yearly" or "monthly"
  const [payment, setPayment] = useState("card");    // "card" or "crypto"

  return (
    <div className="sponsorship-page">
      {/* ─── TOP NAV ─── */}
      <LexacquireTopnav />

      {/* ─── GROWTH PLAN SECTION ─── */}
      <section className="growth-plan-section">
        <h2 className="growth-plan-title">Choose Your Growth Plan</h2>
        <p className="growth-plan-subtitle">
          Lex ensures your business success and maximize your ROI
        </p>

        {/* Billing Toggle */}
        <div className="billing-toggle">
          <button
            className={billing === "yearly" ? "toggle-btn active" : "toggle-btn"}
            onClick={() => setBilling("yearly")}
          >
            Yearly <span className="billing-badge">-40%</span>
          </button>
          <button
            className={billing === "monthly" ? "toggle-btn active" : "toggle-btn"}
            onClick={() => setBilling("monthly")}
          >
            Monthly
          </button>
        </div>

        {/* Payment Method Toggle */}
        <div className="payment-toggle">
          <label className="payment-label">Card</label>
          <div
            className={
              payment === "card" ? "switch-toggle switch-on" : "switch-toggle"
            }
            onClick={() => setPayment(payment === "card" ? "crypto" : "card")}
          >
            <span className="switch-circle" />
          </div>
          <label className="payment-label">Crypto</label>
          <span className="coming-soon-badge">Coming Soon</span>
        </div>

        {/* Plan Cards */}
        <div className="plan-cards-container">
          {/* Free Plan */}
          <div className="plan-card free-plan">
            <div className="plan-content">
              <h3 className="plan-name plan-name-free">Free</h3>
              <p className="plan-tagline">Basic listing in the directory</p>
              <p className="plan-price plan-price-free">
                $0 <span className="plan-duration">/forever</span>
              </p>
              <ul className="plan-features">
                <li>1 Year listing</li>
              </ul>
            </div>
            <button className="plan-action-btn get-listed-btn">
              Get Listed →
            </button>
          </div>

          {/* SEO Boost Plan */}
          <div className="plan-card boost-plan">
            <div className="badge-popular">Popular</div>
            <div className="plan-content">
              <h3 className="plan-name plan-name-boost">SEO Boost</h3>
              <p className="plan-tagline">Permanent SEO boost</p>
              <p className="plan-price plan-price-boost">
                $29 <span className="plan-duration">/one-time</span>
              </p>
              <ul className="plan-features">
                <li>Permanent Listing</li>
                <li>Permanent DoFollow backlink</li>
                <li>1 Guest blog post</li>
                <li>Search visibility</li>
              </ul>
            </div>
            <button className="plan-action-btn book-now-boost">
              Book Now →
            </button>
          </div>

          {/* Starter Plan */}
          <div className="plan-card starter-plan">
            {billing === "yearly" && <div className="badge-save">Save 40%</div>}
            <div className="plan-content">
              <h3 className="plan-name plan-name-starter">Starter</h3>
              <p className="plan-tagline">Perfect for new AI agents</p>
              {billing === "yearly" ? (
                <p className="plan-price plan-price-starter">
                  $59 <span className="plan-duration">/month</span>
                  <br />
                  <span className="plan-annual-text">
                    (annual charge of $708)
                  </span>
                </p>
              ) : (
                <p className="plan-price plan-price-starter">
                  $99 <span className="plan-duration">/month</span>
                </p>
              )}
              <ul className="plan-features">
                <li>20k+ impressions</li>
                <li>Top placement in your category</li>
                <li>Highlight on the AI Agents Map</li>
                <li>Premium partner badge</li>
              </ul>
            </div>
            <button className="plan-action-btn book-now-starter">
              Book Now →
            </button>
          </div>

          {/* Growth Plan */}
          <div className="plan-card growth-plan">
            {billing === "yearly" && <div className="badge-save">Save 40%</div>}
            <div className="plan-content">
              <h3 className="plan-name plan-name-growth">Growth</h3>
              <p className="plan-tagline">Best for scaling AI agents</p>
              {billing === "yearly" ? (
                <p className="plan-price plan-price-growth">
                  $149 <span className="plan-duration">/month</span>
                  <br />
                  <span className="plan-annual-text">
                    (annual charge of $1,788)
                  </span>
                </p>
              ) : (
                <p className="plan-price plan-price-growth">
                  $249 <span className="plan-duration">/month</span>
                </p>
              )}
              <ul className="plan-features">
                <li>100k+ impressions</li>
                <li>Priority in search results</li>
                <li>Featured block across the site</li>
                <li>Featured in the Newsletter</li>
                <li>LinkedIn post promotion</li>
                <li>Priority email support</li>
              </ul>
            </div>
            <button className="plan-action-btn book-now-growth">
              Book Now →
            </button>
          </div>
        </div>
      </section>

      {/* ─── HOW IT WORKS SECTION ─── */}
      <section className="how-it-works-section">
        <h2 className="how-it-works-title">How It Works</h2>

        <div className="steps-container">
          {/* Step 1 */}
          <div className="step-card">
            <div className="step-icon step-icon-card">
              {/* Card icon SVG */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#2563eb"
                viewBox="0 0 24 24"
                width="24px"
                height="24px"
              >
                <path d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4H2V6zm0 6h20v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6z" />
              </svg>
            </div>
            <h3 className="step-title">1. Quick Purchase</h3>
            <p className="step-desc">
              Choose your plan and complete payment securely.
            </p>
          </div>

          <div className="step-arrow">→</div>

          {/* Step 2 */}
          <div className="step-card">
            <div className="step-icon step-icon-email">
              {/* Email icon SVG */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#2563eb"
                viewBox="0 0 24 24"
                width="24px"
                height="24px"
              >
                <path d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4zm2 .5v15l8-7.5L20 19.5v-15L10 11 4 4.5z" />
              </svg>
            </div>
            <h3 className="step-title">2. Confirmation</h3>
            <p className="step-desc">Receive email confirmation.</p>
          </div>

          <div className="step-arrow">→</div>

          {/* Step 3 */}
          <div className="step-card">
            <div className="step-icon step-icon-flash">
              {/* Flash icon SVG */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#2563eb"
                viewBox="0 0 24 24"
                width="24px"
                height="24px"
              >
                <path d="M11 2L3 13h7v9l8-11h-7V2z" />
              </svg>
            </div>
            <h3 className="step-title">3. Start Growing</h3>
            <p className="step-desc">
              Your promotion goes live immediately or on selected date.
            </p>
          </div>
        </div>

        {/* Info Bar */}
        <div className="how-it-works-info-bar">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#2563eb"
            viewBox="0 0 24 24"
            width="20px"
            height="20px"
          >
            <path d="M12 1a11 11 0 1 0 11 11A11.012 11.012 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9zm-.5-4h1v1h-1zm1-9h-1v7h1z" />
          </svg>
          <p className="info-text">
            Questions? Email us at{" "}
            <a href="mailto:ai@lextrackai.com">ai@lextrackai.com</a>
          </p>
        </div>
      </section>
    </div>
  );
}
